module.exports = XMLHttpRequest;
